<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>basic data</el-breadcrumb-item>
      <el-breadcrumb-item>My plumber company</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header
      v-if="visible"
      @back="goBack"
      content="My Plumber Company"
    ></el-page-header>
    <el-divider></el-divider>
    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 搜索与添加区域 -->
      <collapse @getDataList="search" :button-text="'search'">
        <collapse-item id="agency">
          <span class="Staff">Plumber Company:</span>
          <el-input
            placeholder="please enter agency name,pulmber company,contact number,address to search"
            v-model="queryInfoparams.params.keyword"
            clearable
          ></el-input>
        </collapse-item>
        <collapse-item>
          <span class="Source">Source:</span>
          <el-select v-model="queryInfoparams.params.source" placeholder="plase choose" clearable>
            <el-option
              v-for="item in source"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </collapse-item>
        <collapse-item>
          <span class="Status">Status:</span>
          <el-select v-model="queryInfoparams.params.status" placeholder="plase choose" clearable>
            <el-option
              v-for="item in status"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </collapse-item>
      </collapse>
      <el-row type="flex" justify="end">
        <el-col class="searchBtns" :span="6">
          <el-button-group>
            <el-button
              plain
              size="small"
              icon="el-icon-plus"
              @click="addEditDialog"
              v-hasPermission="['company:add']"
            >add</el-button>
            <el-button
              plain
              size="small"
              icon="el-icon-download"
              @click="exportData"
              v-hasPermission="['company:export']"
            >Export</el-button>
             <el-button
              plain
              size="small"
              icon="el-icon-check"
              @click="enableEngineerCompany()"
              v-hasPermission="['company:enable']"
            >enable</el-button>
             <el-button
              plain
              size="small"
              icon="el-icon-close"
              @click="suspendEngineerCompany()"
              v-hasPermission="['company:updateStatus']"
            >suspend</el-button>
          </el-button-group>
        </el-col>
      </el-row>
      <el-table :data="dataList" border stripe style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column    type="selection"      width="55"></el-table-column>
        <el-table-column type="index" label="No."></el-table-column>
        <el-table-column label="Agent" sortable prop="agencyName" width="160px"></el-table-column>
        <el-table-column label="Plumbing company" sortable prop="companyName" width="180px"></el-table-column>
        <el-table-column label="E-mail" sortable prop="email" width="160px"></el-table-column>
        <!-- <el-table-column label="Account" sortable prop="loginAccount"></el-table-column> -->
        <!-- <el-table-column label="FirstName" sortable prop="firstName"></el-table-column>
        <el-table-column label="Surname" sortable prop="lastName"></el-table-column>-->
        <el-table-column label="Invitation code" sortable prop="invitationCode" width="160px"></el-table-column>
        <el-table-column label="Contact number" sortable prop="mobileNumber" width="160px"></el-table-column>
        <el-table-column label="Area" sortable prop="detailAddress" width="160px"></el-table-column>
        <el-table-column label="Address" sortable prop="address" width="160px"></el-table-column>
        <el-table-column label="Post code" sortable prop="postCode" width="160px"></el-table-column>
        <el-table-column label="Source" sortable prop="source" width="160px"></el-table-column>-->
        <el-table-column label="Status" sortable prop="status" width="160px">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status==='0'">Enable</el-tag>
            <el-tag v-else-if="scope.row.status==='1'">Disable</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="Testing standard" sortable prop="testStandard" width="160px"></el-table-column>
        <el-table-column label="Create date" sortable prop="createdTime" width="160px"></el-table-column>
        <el-table-column label="operate" width="180px" fixed="right" fit>
          <!-- 按钮 -->
          <template slot-scope="scope">
            <div class="btnContainer">
              <el-link
                plain
                size="small"
                icon="el-icon-edit-outline"
                @click="showEditDialog(scope.row.id)"
                v-hasPermission="['plumbercompany:edit']"
              >edit</el-link>
              <!-- <el-link
                plain
                size="small"
                icon="el-icon-edit-outline"
                @click="enableEngineerCompany(scope.row.id,scope.row.userId)"
                v-hasPermission="['plumbercompany:enable']"
              >enable</el-link> -->
              <!-- <el-link
                plain
                size="small"
                icon="el-icon-edit-outline"
                @click="suspendEngineerCompany(scope.row.id,scope.row.userId)"
                v-hasPermission="['plumbercompany:suspend']"
              >suspend</el-link> -->
              <el-link
                plain
                size="small"
                icon="el-icon-view"
                @click="clickHandlerToPlumber(scope.row.id)"
                v-hasPermission="['plumbercompany:employee']"
              >Detail</el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfoparams.current"
        :page-sizes="[10, 50, 100, 200]"
        :page-size="queryInfoparams.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>

    <!-- 添加水工公司的对话框 -->
    <el-dialog
      title="Please Enter"
      :visible="addDialogVisible"
      width="50%"
      @close="addDialogClosed"
    >
      <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="70px">
        <el-row>
          <el-input id="displayInput" v-model="addForm.agencyId"></el-input>
          <el-col :span="12">
            <el-form-item class="left" label="Agent" prop="agencyName" label-width="160px">
              <el-input placeholder=" enter the agent" v-model="addForm.agencyName" disabled></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="Email" prop="email" label-width="160px">
              <el-input placeholder=" enter the email" v-model="addForm.email"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              class="companyName"
              label-position="left"
              label="Company name"
              prop="companyName"
              label-width="160px"
            >
              <el-input placeholder=" enter the company name" v-model="addForm.companyName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Contact number" prop="mobileNumber" label-width="160px">
              <el-input placeholder=" enter the contact number" v-model="addForm.mobileNumber"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="First name" prop="firstName" label-width="160px">
              <el-input placeholder=" enter the first name" v-model="addForm.firstName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Surname" prop="lastName" label-width="160px">
              <el-input placeholder=" enter the surname" v-model="addForm.lastName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="Area" prop="areaList" label-width="160px">
              <el-cascader
                placeholder=" select area"
                filterable
                style="width:100%"
                lazy="true"
                clearable
                size="medium"
                v-model="areaList"
                :props="{value:'id',label:'label',leaf:'hasChildren',checkStrictly: true}"
                :options="areaTreeList"
                ref="treeArea"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Detail address" prop="address" label-width="160px">
              <el-input placeholder=" enter the detail address" v-model="addForm.address"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="Invitation code rules"
              prop="pipelineShortName"
              label-width="160px"
            >
              <el-input
                placeholder=" enter the three-character"
                v-model="addForm.pipelineShortName"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Post code" prop="postCode" label-width="160px">
              <el-input placeholder=" enter post code" v-model="addForm.postCode"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="Testing standard" prop="testStandard" label-width="160px">
              <el-radio-group
                v-model="addForm.testStandard"
                v-for="(item,index) in testStandardList"
                :key="index"
              >
                <el-radio-button :label="item.value" :disabled="testStandardisDisable">{{item.text}}</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="addEngineerCompany(userId,companyId)">Save</el-button>
      </span>
    </el-dialog>
    <!-- 修改水工公司的对话框  此处可与添加水工公司 优化合并为一个对话框-->
    <el-dialog
      title="Edit Company"
      :visible.sync="editDialogVisible"
      width="50%"
      @close="editDialogClosed"
    >
      <el-form :model="addForm" :rules="addFormRules" ref="editFormRef" label-width="70px">
        <el-row>
          <el-input id="displayInput" v-model="addForm.agencyId"></el-input>
          <el-input id="displayInput" v-model="addForm.id"></el-input>
          <el-col :span="12">
            <el-form-item class="left" label="Agent" prop="agencyName" label-width="160px">
              <el-input placeholder=" enter the agent" v-model="addForm.agencyName" disabled></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item class="email" prop="email" label="Email" label-width="160px">
              <el-input placeholder=" enter the email" v-model="addForm.email"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              class="companyName"
              label-position="left"
              label="Company name"
              prop="companyName"
              label-width="160px"
            >
              <el-input placeholder=" enter the company name" v-model="addForm.companyName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Contact number" prop="mobileNumber" label-width="160px">
              <el-input placeholder=" enter the contact number" v-model="addForm.mobileNumber"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row></el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="Area" prop="areaList" label-width="160px">
              <el-cascader
                filterable
                placeholder=" select area"
                style="width:100%"
                clearable
                size="medium"
                v-model="areaList"
                :props="{value:'id',label:'label',leaf:'hasChildren',checkStrictly: true}"
                :options="areaTreeList"
                ref="treeArea"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Detail address" prop="address" label-width="160px">
              <el-input placeholder=" enter the detail address" v-model="addForm.address"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="Invitation code rules"
              prop="pipelineShortName"
              label-width="160px"
            >
              <el-input
                placeholder=" enter the three-character"
                v-model="addForm.pipelineShortName"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Post code" prop="postCode" label-width="160px">
              <el-input placeholder=" enter post code" v-model="addForm.postCode"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="TestingStandard" prop="testStandard" label-width="160px">
              <el-radio-group
                v-model="addForm.testStandard"
                v-for="(item,index) in testStandardList"
                :key="index"
              >
                <el-radio-button :label="item.value" :disabled="testStandardisDisable">{{item.text}}</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="editEngineerCompany">Save</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import db from '@/services/localstorage'
import Collapse from '@/components/collapse/Collapse'
import CollapseItem from '@/components/collapse/CollapseItem'
export default {
  components: { Collapse, CollapseItem },
  data() {
    var checkEmail = (rule, value, cb) => {
      // 验证邮箱的正则表达式
      const regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9])+/
      if (regEmail.test(value)) {
        return cb()
      }
      cb(new Error('please enter a valid email'))
    }
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: 'last Week',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: 'last Month',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: 'last three Month',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      source: [
        {
          value: 'SYS-registered',
          label: 'SYS-registered',
        },
        {
          value: 'Self-registered',
          label: 'Self-registered',
        },
      ],
      testStandardList: [],
      status: [
        {
          value: '0',
          label: 'Enable',
        },
        {
          value: '1',
          label: 'Disable',
        },
      ],
      addressOptions: [
        {
          value: '',
          label: '',
        },
      ],
      userId: '',
      value: '',
      areaList: [],
      queryInfoparams: {
        // 当前页码
        current: 0,
        // 查询参数
        params: {},
        // 当前每页显示多少条数据
        size: 10,
        // 排序字段
        sortField: '',
        // ASC  DESC 顺序
        sortOrder: '',
      },
      dataList: [],
      addForm: {
        agencyName: '',
        email: '',
        companyName: '',
        loginAccount: '',
        firstName: '',
        mobileNumber: '',
        lastName: '',
        postCode: '',
        address: '',
        userId: '',
        source: '',
        id: '',
        agencyId: this.$route.query.agencyId,
        pipelineShortName: '',
        testStandard: '',
        areaFullpath: '',
        areaList:''
      },
      areaList:[],
      visible:this.$route.query.visible,
      multipleSelection:[],
      testStandardisDisable: false,
      userId: '',
      companyId: '',
      // 添加表单的验证规则对象
      addFormRules: {
        agencyName: [
          {
            required: true,
            message: 'Agent name is required',
            trigger: 'blur',
          },
          {
            max: 300,
            message: 'Agent name can not more than 300 character',
            trigger: 'blur',
          },
        ],
        companyName: [
          {
            required: true,
            message: 'Pipeine code is required',
            trigger: 'blur',
          },
          {
            max: 300,
            message: 'Company Name can not more than 300 character',
            trigger: 'blur',
          },
        ],
       email: [
          { required: true, message: 'Email is required', trigger: 'blur' }
        ],
        address: [
          { required: true, message: 'address is required', trigger: 'blur' },
        ],
        pipelineShortName: [
          {
            required: true,
            message: 'Only enter three letters character',
            trigger: 'blur',
          },
          {
            min: 3,
            max: 3,
            message: 'Only enter three letters character',
            trigger: 'blur',
          },
        ],
        mobileNumber: [
          {
            required: true,
            message: 'Mobile Number is required',
            trigger: 'blur',
          },
        ],
        postCode: [
          { required: true, message: 'Post Code is required', trigger: 'blur' },
        ],
        testStandard: [
          {
            required: true,
            message: 'Test Standard is required',
            trigger: 'blur',
          },
        ],
        firstName: [
          {
            required: true,
            message: 'First name is required',
            trigger: 'blur',
          },
        ],
        lastName: [
          { required: true, message: 'Last name is required', trigger: 'blur' },
        ],
         areaList: [ { required: true, message: 'Area is required', trigger: 'blur' }  ],
      },
      total: 0,
      // 控制添加 对话框的显示与隐藏
      addDialogVisible: false,
      // 控制修改用户对话框的显示与隐藏
      editDialogVisible: false,
      areaTreeList: [],
    }
  },

  created() {
    var user = db.get('user')
    this.userId = user.userId
    this.addForm.companyId = user.userId
    this.companyId = user.companyId
    this.getTestStandardDictList()
    this.search()
  },
  methods: {

    goBack() {
      this.$router.back()
    },
    //获取区域地址信息
    getAreaTreeList() {
      this.$get(`tree/getTreeByCode/TREE_PROVINCE/Y/false`).then(
        ({ data: res }) => {
          this.areaTreeList = res.data
        }
      )
    },
    search(){
        this.queryInfoparams.current=0
         this.getDataList()
    },
    // 获取 查询数据列表
    getDataList() {
      this.$post('engineerCompany/pageQuery', this.queryInfoparams).then(
        ({ data: res }) => {
          this.dataList = res.records
          this.total = res.total
        }
      )
    },
    //获取TestStandard数据字典列表
    getTestStandardDictList() {
      this.$get(`dict/getByTypeCodeAsFilter/TEST_STANDARD/Y`).then(
        ({ data: res }) => {
          this.testStandardList = res.data
        }
      )
    },
     //选择行事件
     handleSelectionChange(val) {
        
        this.multipleSelection = val;
      },
    // 监听pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfoparams.size = newSize
      this.getDataList()
    },
    // 监听页码值 改变的事件
    handleCurrentChange(newPage) {
      this.queryInfoparams.current = newPage
      this.getDataList()
    },
    clickHandlerToPlumber(id) {

      this.$router.push({
        path: '/plumberCompany/engineerCompany',
        query: { companyId: id ,visible:true}
      })
    },
    // 监听添加用户对话框的关闭事件
    addDialogClosed() {
      this.addDialogVisible = false
      this.$refs.addFormRef.resetFields()
    },
    // 点击按钮 添加

    async addEngineerCompany(userId) {

       this.addForm.areaList=this.areaList;
      this.$refs.addFormRef.validate(async (valid) => {
       this.addForm.areaFullpath=this.areaList.join(',');
       this.addForm.areaList=null;
       this.addForm.source="EMPLOYEE";
       this.addForm.companyId=userId;
        if (!valid) return
         const loading = this.$loading({
          lock: true,
          text: 'Saving',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        })
       this.$post('engineerCompany/add', JSON.stringify(this.addForm)).then(({ data: res }) => {


          if (res.msg !== 'successfully') {
            loading.close()
            return this.$message.error('Add the plumber company unsuccessfully')
          }
          loading.close()
          this.addDialogVisible = false
          this.$message.success('Add the plumber company successfully')
          // 刷新数据列表
          this.search()
          // 提示修改成功
        }
      )
      })
    },
    // 点击按钮 添加
    async exportData() {
      console.log('queryInfoparams:' + this.queryInfoparams.params.userType)
      // addForm.userId=db.get("userId")
      let res = this.$export(
        'engineerCompany/exportExcel',
        JSON.stringify(this.queryInfoparams),
        'plumber_information'
      )
    },

    editDialogClosed() {
      this.editDialogVisible = false
      this.$refs.editFormRef.resetFields()
    },
    // 展示新增用户的对话框
    async addEditDialog() {
      this.getAreaTreeList()
      this.addDialogVisible = true
      this.addForm = {}
      this.$get(`agent/getCurrentAgent`).then(({ data: res }) => {
        this.addForm = {
          agencyName: res.data.agencyName,
          agencyId: res.data.agentId,
          testStandard: res.data.testStandard,
        }
        this.areaList=null;
        if ('STANDARD' == res.data.testStandard) {
          this.testStandardisDisable = true
        }
      })
    },
    // 展示编辑用户的对话框
    async showEditDialog(id) {
      this.getAreaTreeList()
      this.editDialogVisible = true
      this.$get(`engineerCompany/queryEngineerCompanyById/${id}`).then(
        ({ data: res }) => {
         debugger
          this.addForm = {
            agencyId: res.agencyId,
            agencyName: res.agencyName,
            email: res.email,
            companyName: res.companyName,
            firstName: res.firstName,
            mobileNumber: res.mobileNumber,
            lastName: res.lastName,
            postCode: res.postCode,
            address: res.address,
            pipelineShortName: res.pipelineShortName,
            id: res.id,
            testStandard: res.testStandard,
            areaList: res.areaList,
          }
          this.areaList=res.areaList
          console.log(this.areaList);
          if ('STANDARD' == res.agencyStandard) {
            this.testStandardisDisable = true
          }
        }
      )
    },

    enableEngineerCompany() {
      if(this.multipleSelection.length<1){
        return this.$message.error('please select one record')
      }else{
      var id;
      for(var i=0;i<this.multipleSelection.length;i++){
        if(i==0){
           id=this.multipleSelection[i].id
        }else{
            id=id+","+this.multipleSelection[i].id
        }

         this.$get(`engineerCompany/updateEngineerCompanyStatus/${id}/${0}`).then(
        ({ data: res }) => {
          console.log('msg' + res.msg)
          if (res.msg !== 'successfully') {
            return this.$message.error('Enabled unsuccessfully')
          }
          // 刷新数据列表
          this.search()
          this.$message.success('Enabled successfully')
        }
       )
      }  
      }
    },
    suspendEngineerCompany() {

      if(this.multipleSelection.length<1){
        return this.$message.error('please select one record')
      }else{
         var id;
         for(var i=0;i<this.multipleSelection.length;i++){
        if(i==0){
           id=this.multipleSelection[i].id
        }else{
            id=id+","+this.multipleSelection[i].id
        }
         this.$get(`engineerCompany/updateEngineerCompanyStatus/${id}/${1}`).then(
        ({ data: res }) => {
          if (res.msg !== 'successfully') {
            return this.$message.error('Disabled unsuccessfully')
          }
          // 刷新数据列表
          this.search()
          // 提示修改成功
          this.$message.success('Disabled successfully')
        }
       )
      }      
      }
    },

    editEngineerCompany() {
      
      this.addForm.areaFullpath = this.areaList.join(',')
      this.$refs.editFormRef.validate(async (valid) => {
        
        this.addForm.areaList=null
        if (!valid) return
          const loading = this.$loading({
          lock: true,
          text: 'Saving',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        })
        this.$post('engineerCompany/edit', this.addForm).then(
          ({ data: res }) => {
            console.log(res)
            if (res.msg !== 'successfully') {
               loading.close()
              return this.$message.error('Edit unsuccessfully')
            }
             loading.close()
            // 关闭对话框
            this.editDialogVisible = false
            // 刷新数据列表
            this.search()
            // 提示修改成功
            this.$message.success('Edit successfully')
          }
        )
      })
    },
    async reset() {
      this.queryInfoparams.params.agencyName = ''
      this.queryInfoparams.params.companyName = ''
      this.queryInfoparams.params.email = ''
      this.queryInfoparams.params.mobileNumber = ''
      this.queryInfoparams.params.area = ''
      this.queryInfoparams.params.address = ''
      this.queryInfoparams.params.source = ''
      this.queryInfoparams.params.status = ''
    },
  },
}
</script>

<style lang="less" scoped>
.el-select {
  width: 100%;
}

/deep/.el-collapse-item__content {
  display: flex;
  justify-content: space-between;
}

.collapseBtn {
  height: 40px;
}

.searchBtns {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

/deep/.el-collapse-item__wrap {
  border: none !important;
}
/deep/.el-collapse-item__header {
  border: none !important;
}

.el-row {
  flex: 1;
}

#el-collapse-head-4510 {
  height: auto;
}
.el-col {
  display: flex;
}
.el-date-editor {
  height: auto;
  width: auto;
}
.demonstration1 {
  height: auto;
  width: 25%;
}
.el-button {
  height: auto;
  width: auto;
}
.left {
  width: auto;
}
#el-input__inner {
  width: 200px;
}
/deep/#displayInput {
  display: none;
}
</style>